export default "__VITE_ASSET__bca94926__"